// extracted by mini-css-extract-plugin
export default {"more":"RelationshipsSection_more__QgEQy"};